import { Validator } from 'quival';

// Normal checkers
Validator.addChecker('enum', function (attribute, value, parameters) {
    return this.checkIn(attribute, value, parameters);
});

Validator.addChecker('phone_number', function (attribute, value, parameters) {
    return /^\+?\d[\d\-() ]+$/.test(value) && String(value).replace(/\D/g, '').length >= 7;
});

Validator.addChecker('in_ci', function (attribute, value, parameters) {
    if (this.checkArray(attribute, value) && this.validator.hasRule(attribute, 'array')) {
        value = Object.values(value).map((item) => String(item).toLocaleUpperCase());
    } else {
        value = String(value).toLocaleUpperCase();
    }

    parameters = Object.values(parameters).map((item) => String(item).toLocaleUpperCase());

    return this.checkIn(attribute, value, parameters);
});

Validator.addChecker('not_in_ci', function (attribute, value, parameters) {
    return !this.checkInCi(attribute, value, parameters);
});

['hcaptcha', 'turnstile', 'precognition'].forEach((checker) => {
    Validator.addChecker(checker, function (attribute, value, parameters) {
        return true;
    });
});

Validator.addChecker('not_only_number', function (attribute, value, parameters) {
    return this.testStringUsingRegex(attribute, value, /\D/, /[^\p{N}]/u, parameters.includes('ascii'));
});

Validator.addChecker('starts_with_alpha', function (attribute, value, parameters) {
    return this.testStringUsingRegex(attribute, value, /^[a-z]/i, /^[\p{L}\p{M}]/u, parameters.includes('ascii'));
});

Validator.addChecker('starts_with_number', function (attribute, value, parameters) {
    return this.testStringUsingRegex(attribute, value, /^[0-9]/, /^[\p{N}]/u, parameters.includes('ascii'));
});

Validator.addChecker('password', function (attribute, value, parameters) {
    const options = {
        mixed: /(\p{Ll}+.*\p{Lu})|(\p{Lu}+.*\p{Ll})/u,
        letters: /\p{L}/u,
        symbols: /\p{Z}|\p{S}|\p{P}/u,
        numbers: /\p{N}/u,
    };

    let success = true,
        message;

    for (const [option, pattern] of Object.entries(options)) {
        if (parameters.includes(option) && !pattern.test(value)) {
            success = false;
            message = this.validator.getMessage(attribute, `password.${option}`);

            break;
        }
    }

    return { success, message, status: success };
});

Validator.addChecker('js', function (attribute, value, parameters) {
    const callback = window._validatorCallbackRules?.[parameters[0]] ?? null;

    if (!callback) {
        console.warn(`Callback rule "${parameters[0]}" not found.`);
        return true;
    }

    return callback.call(this, attribute, value, parameters);
});

// Replacers
Validator.addReplacer('in_ci', function (message, attribute, value, parameters) {
    return this.replaceIn(message, attribute, value, parameters);
});

Validator.addReplacer('not_in_ci', function (message, attribute, value, parameters) {
    return this.replaceIn(message, attribute, value, parameters);
});

// Export Validator class
export default Validator;
